import { reactive } from 'vue';
import { IState } from '@/models/store/store.interface';
import { Routes } from '@/models/router/router.interface';
import { ModalCustomProductStates, ModalErrorStates, ModalUnsafeExitStates } from '@/models/modal/modal.enum';
import { DeliveryType, Region } from '@studyportals/campaign-management-api-interface';
import { InvalidCampaignPropertyCategories } from '@/models/error.interface';
import { NotificationStatuses } from '@/models/notifications.interface';
import { LoadingStatuses } from '@/models/loading.interface';

const state = reactive<IState>({
	accountManager: null,
	allAccountManagers: [],
	allClientServicesPeople: [],
	allPricingProducts: [],
	auditorEntries: [],
	availableEntities: [],
	budgetCustom: null,
	budgetListing: null,
	budgetTotal: null,
	campaignLiftExcluded: false,
	campaignReadinessInfo: null,
	campaignType: null,
	clientServicesPerson: null,
	crmId: null,
	currency: null,
	customProducts: [],
	deliveryMode: {
		type: DeliveryType.EVENLY
	},
	duplicateEntryCampaignDetails: null,
	endDate: null,
	entitiesAffectedByUnlinking: [],
	entitySearchQuery: '',
	idsOfModifiedCustomProducts: [],
	internalNotes: '',
	invalidCampaignPropertyDetails: {
		category: InvalidCampaignPropertyCategories.UNSET,
		value: ''
	},
	isGeotargetingMicroserviceReady: false,
	linkedOrganisations: [],
	loadCount: 0,
	loadingStatusAccountManagers: LoadingStatuses.INACTIVE,
	loadingStatusAuditorEntries: LoadingStatuses.ACTIVE,
	loadingStatusCampaignReadinessInfo: LoadingStatuses.ACTIVE,
	loadingStatusClientServicesPeople: LoadingStatuses.INACTIVE,
	loadingStatusCustomProducts: LoadingStatuses.ACTIVE,
	loadingStatusEntities: LoadingStatuses.ACTIVE,
	loadingStatusPricingProducts: LoadingStatuses.ACTIVE,
	loadingStatusPrimaryData: LoadingStatuses.ACTIVE,
	loadingStatusRights: LoadingStatuses.ACTIVE,
	modalCustomProductState: ModalCustomProductStates.INACTIVE,
	modalErrorState: ModalErrorStates.INACTIVE,
	modalUnsafeExitState: ModalUnsafeExitStates.INACTIVE,
	name: '',
	notificationStatus: NotificationStatuses.INACTIVE,
	originalCampaignData: null,
	overlappingCampaignsCluster: null,
	partnershipType: null,
	persistGLParamRefLink: false,
	region: Region.OTHER,
	rightsUsers: [],
	router: {
		current: Routes.GENERAL,
		next: null,
		props: {
			id: 0,
			isCampaignCreation: false
		}
	},
	selectedCustomProductId: null,
	selectedTypeForCustomProductCreation: null,
	selectedTableActionsDropdown: -1,
	standAloneLogin: false,
	startDate: null,
	validationInfoDates: {
		message: '',
		invalidTypes: []
	},
	validationResult: {
		missing: [],
		invalid: [],
		valid: []
	}
});

export default state;
